import { create } from '~/utils/store/createStore';

interface ChatInputState {
  hasUserInteracted: boolean;
  setHasUserInteracted: (value: boolean) => void;
}

export const useChatInputStore = create<ChatInputState>(set => ({
  hasUserInteracted: false,
  setHasUserInteracted: (value: boolean) => set({ hasUserInteracted: value }),
}));
